export const formatContractTitle = (title: string): string =>
	title.replace(/^(\*\*|__)(.+)\1$/u, '$2').trim();
